<div class="w-full mx-auto min-h-screen p-5 bg-gray-50">
    <!-- Header Section -->
    <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div class="flex justify-between items-center">
            <div>
                <h1 class="text-3xl font-bold text-gray-900 mb-2">
                    Perfil del Tercero: {{ profile?.thirdParty?.firstName }} {{ profile?.thirdParty?.lastName }}
                </h1>
                <p class="text-gray-600">
                    Información detallada y movimientos financieros del tercero.
                </p>
            </div>
            <div class="flex space-x-3">
                <button 
                    type="button" 
                    (click)="goToEdit()" 
                    class="px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 transition-colors flex items-center">
                    <i class="fas fa-edit mr-2"></i>Editar Tercero
                </button>
                <button 
                    type="button" 
                    (click)="goBack()" 
                    class="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition-colors flex items-center">
                    <i class="fas fa-arrow-left mr-2"></i>Volver al Listado
                </button>
            </div>
        </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-10">
        <i class="fas fa-spinner fa-spin text-4xl text-blue-500"></i>
        <p class="mt-4 text-gray-600">Cargando perfil del tercero...</p>
    </div>

    <div *ngIf="!isLoading && profile" class="space-y-6">
        <!-- Financial Summary Dashboard -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <!-- Total Work Orders -->
            <div class="bg-white rounded-lg shadow-sm p-6 border-l-4 border-blue-500">
                <div class="flex items-center">
                    <div class="flex-shrink-0">
                        <i class="fas fa-clipboard-list text-blue-500 text-2xl"></i>
                    </div>
                    <div class="ml-4">
                        <h3 class="text-sm font-medium text-gray-500">Total Órdenes de Trabajo</h3>
                        <p class="text-2xl font-bold text-gray-900">{{ formatCurrency(profile.financialSummary?.totalWorkOrders || 0) }}</p>
                    </div>
                </div>
            </div>

            <!-- Total Expense Vouchers -->
            <div class="bg-white rounded-lg shadow-sm p-6 border-l-4 border-green-500">
                <div class="flex items-center">
                    <div class="flex-shrink-0">
                        <i class="fas fa-receipt text-green-500 text-2xl"></i>
                    </div>
                    <div class="ml-4">
                        <h3 class="text-sm font-medium text-gray-500">Total Comprobantes Egreso</h3>
                        <p class="text-2xl font-bold text-gray-900">{{ formatCurrency(profile.financialSummary?.totalExpenseVouchers || 0) }}</p>
                    </div>
                </div>
            </div>

            <!-- Total Pending -->
            <div class="bg-white rounded-lg shadow-sm p-6 border-l-4 border-yellow-500">
                <div class="flex items-center">
                    <div class="flex-shrink-0">
                        <i class="fas fa-hourglass-half text-yellow-500 text-2xl"></i>
                    </div>
                    <div class="ml-4">
                        <h3 class="text-sm font-medium text-gray-500">Total Pendiente</h3>
                        <p class="text-2xl font-bold text-gray-900">{{ formatCurrency(profile.financialSummary?.totalPending || 0) }}</p>
                    </div>
                </div>
            </div>

            <!-- Net Balance -->
            <div class="bg-white rounded-lg shadow-sm p-6 border-l-4 border-purple-500">
                <div class="flex items-center">
                    <div class="flex-shrink-0">
                        <i class="fas fa-balance-scale text-purple-500 text-2xl"></i>
                    </div>
                    <div class="ml-4">
                        <h3 class="text-sm font-medium text-gray-500">Balance Neto</h3>
                        <p class="text-2xl font-bold text-gray-900">{{ formatCurrency(profile.financialSummary?.netBalance || 0) }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabs Navigation -->
        <div class="bg-white rounded-lg shadow-sm p-4 mb-6">
            <div class="flex border-b border-gray-200">
                <button 
                    (click)="setActiveTab('overview')"
                    [class]="isActiveTab('overview') ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                    class="w-1/4 py-2 px-1 text-center border-b-2 font-medium text-sm transition-colors">
                    <i class="fas fa-chart-pie mr-2"></i>Resumen
                </button>
                <button 
                    (click)="setActiveTab('workOrders')"
                    [class]="isActiveTab('workOrders') ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                    class="w-1/4 py-2 px-1 text-center border-b-2 font-medium text-sm transition-colors">
                    <i class="fas fa-clipboard-list mr-2"></i>Órdenes de Trabajo
                </button>
                <button 
                    (click)="setActiveTab('expenseVouchers')"
                    [class]="isActiveTab('expenseVouchers') ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                    class="w-1/4 py-2 px-1 text-center border-b-2 font-medium text-sm transition-colors">
                    <i class="fas fa-receipt mr-2"></i>Comprobantes de Egreso
                </button>
                <button 
                    (click)="setActiveTab('otherMovements')"
                    [class]="isActiveTab('otherMovements') ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                    class="w-1/4 py-2 px-1 text-center border-b-2 font-medium text-sm transition-colors">
                    <i class="fas fa-exchange-alt mr-2"></i>Otros Movimientos
                </button>
            </div>
        </div>

        <!-- Tab Content -->
        <div class="bg-white rounded-lg shadow-sm p-6">
            
            <!-- Overview Tab -->
            <div *ngIf="isActiveTab('overview')" class="space-y-6">
                <h2 class="text-xl font-semibold text-gray-900 mb-4">Resumen General</h2>
                
                <!-- Personal Information -->
                <div class="bg-gray-50 rounded-lg p-6">
                    <h3 class="text-lg font-medium text-gray-900 mb-4">Información Personal</h3>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div>
                            <span class="text-sm font-medium text-gray-500">Nombres:</span>
                            <p class="text-sm text-gray-900">{{ profile.thirdParty?.firstName }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Apellidos:</span>
                            <p class="text-sm text-gray-900">{{ profile.thirdParty?.lastName }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Documento:</span>
                            <p class="text-sm text-gray-900">{{ profile.thirdParty?.documentId }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Email:</span>
                            <p class="text-sm text-gray-900">{{ profile.thirdParty?.email }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Teléfono:</span>
                            <p class="text-sm text-gray-900">{{ profile.thirdParty?.phone }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Celular:</span>
                            <p class="text-sm text-gray-900">{{ profile.thirdParty?.cellPhone }}</p>
                        </div>
                    </div>
                </div>

                <!-- Financial Summary -->
                <div class="bg-gray-50 rounded-lg p-6">
                    <h3 class="text-lg font-medium text-gray-900 mb-4">Resumen Financiero</h3>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div>
                            <span class="text-sm font-medium text-gray-500">Órdenes Activas:</span>
                            <p class="text-sm text-gray-900">{{ profile.financialSummary?.activeWorkOrders || 0 }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Órdenes Completadas:</span>
                            <p class="text-sm text-gray-900">{{ profile.financialSummary?.completedWorkOrders || 0 }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Total Transacciones:</span>
                            <p class="text-sm text-gray-900">{{ profile.financialSummary?.totalTransactions || 0 }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Última Orden:</span>
                            <p class="text-sm text-gray-900">{{ profile.financialSummary?.lastWorkOrderDate ? formatDate(profile.financialSummary.lastWorkOrderDate) : 'N/A' }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Último Comprobante:</span>
                            <p class="text-sm text-gray-900">{{ profile.financialSummary?.lastExpenseDate ? formatDate(profile.financialSummary.lastExpenseDate) : 'N/A' }}</p>
                        </div>
                        <div>
                            <span class="text-sm font-medium text-gray-500">Última Transacción:</span>
                            <p class="text-sm text-gray-900">{{ profile.financialSummary?.lastTransactionDate ? formatDate(profile.financialSummary.lastTransactionDate) : 'N/A' }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Work Orders Tab -->
            <div *ngIf="isActiveTab('workOrders')" class="space-y-4">
                <h2 class="text-xl font-semibold text-gray-900 mb-4">Órdenes de Trabajo</h2>
                
                <div *ngIf="profile.workOrders && profile.workOrders.length > 0; else noWorkOrders" class="space-y-4">
                    <div *ngFor="let workOrder of profile.workOrders" class="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                        <div class="flex justify-between items-start mb-3">
                            <div>
                                <h3 class="text-lg font-medium text-gray-900">Orden #{{ workOrder.id }}</h3>
                                <p class="text-sm text-gray-600">Fecha: {{ formatDate(workOrder.paymentDate) }}</p>
                            </div>
                            <span [class]="getWorkOrderStatusClass(workOrder.status)" class="px-2 py-1 text-xs font-medium rounded-full">
                                {{ getWorkOrderStatusText(workOrder.status) }}
                            </span>
                        </div>
                        
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                            <div>
                                <span class="font-medium text-gray-500">Monto Base:</span>
                                <p class="text-gray-900">{{ formatCurrency(workOrder.totalBaseAmount) }}</p>
                            </div>
                            <div>
                                <span class="font-medium text-gray-500">IVA:</span>
                                <p class="text-gray-900">{{ formatCurrency(workOrder.totalVatAmount) }}</p>
                            </div>
                            <div>
                                <span class="font-medium text-gray-500">Total a Pagar:</span>
                                <p class="text-gray-900 font-semibold">{{ formatCurrency(workOrder.totalToPay) }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-template #noWorkOrders>
                    <div class="text-center py-8">
                        <i class="fas fa-clipboard-list text-gray-400 text-4xl mb-4"></i>
                        <p class="text-gray-500">No hay órdenes de trabajo registradas para este tercero.</p>
                    </div>
                </ng-template>
            </div>

            <!-- Expense Vouchers Tab -->
            <div *ngIf="isActiveTab('expenseVouchers')" class="space-y-4">
                <h2 class="text-xl font-semibold text-gray-900 mb-4">Comprobantes de Egreso</h2>
                
                <div *ngIf="profile.expenseVouchers && profile.expenseVouchers.length > 0; else noExpenseVouchers" class="space-y-4">
                    <div *ngFor="let expense of profile.expenseVouchers" class="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                        <div class="flex justify-between items-start mb-3">
                            <div>
                                <h3 class="text-lg font-medium text-gray-900">Comprobante #{{ expense.id }}</h3>
                                <p class="text-sm text-gray-600">{{ expense.concept }}</p>
                                <p class="text-sm text-gray-500">{{ formatDate(expense.paymentDate) }}</p>
                            </div>
                            <span class="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                                {{ expense.isBankReconciled ? 'Conciliado' : 'Pendiente' }}
                            </span>
                        </div>
                        
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                            <div>
                                <span class="font-medium text-gray-500">Banco:</span>
                                <p class="text-gray-900">{{ expense.bank?.bankName }}</p>
                            </div>
                            <div>
                                <span class="font-medium text-gray-500">Monto Total:</span>
                                <p class="text-gray-900">{{ formatCurrency(expense.totalAmount) }}</p>
                            </div>
                            <div>
                                <span class="font-medium text-gray-500">Total a Pagar:</span>
                                <p class="text-gray-900 font-semibold">{{ formatCurrency(expense.totalToPay) }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-template #noExpenseVouchers>
                    <div class="text-center py-8">
                        <i class="fas fa-receipt text-gray-400 text-4xl mb-4"></i>
                        <p class="text-gray-500">No hay comprobantes de egreso registrados para este tercero.</p>
                    </div>
                </ng-template>
            </div>

            <!-- Other Movements Tab -->
            <div *ngIf="isActiveTab('otherMovements')" class="space-y-6">
                <h2 class="text-xl font-semibold text-gray-900 mb-4">Otros Movimientos</h2>
                
                <!-- Credit Notes -->
                <div class="space-y-4">
                    <h3 class="text-lg font-medium text-gray-800">Notas de Crédito</h3>
                    <div *ngIf="profile.creditNotes && profile.creditNotes.length > 0; else noCreditNotes" class="space-y-3">
                        <div *ngFor="let credit of profile.creditNotes" class="border border-gray-200 rounded-lg p-4">
                            <div class="flex justify-between items-start">
                                <div>
                                    <h4 class="text-md font-medium text-gray-900">Nota #{{ credit.documentNumber }}</h4>
                                    <p class="text-sm text-gray-600">{{ credit.concept }}</p>
                                    <p class="text-sm text-gray-500">{{ formatDate(credit.documentDate) }}</p>
                                </div>
                                <div class="text-right">
                                    <p class="text-lg font-semibold text-green-600">{{ formatCurrency(credit.amount) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #noCreditNotes>
                        <p class="text-gray-500 text-sm">No hay notas de crédito registradas.</p>
                    </ng-template>
                </div>

                <!-- Debit Notes -->
                <div class="space-y-4">
                    <h3 class="text-lg font-medium text-gray-800">Notas de Débito</h3>
                    <div *ngIf="profile.debitNotes && profile.debitNotes.length > 0; else noDebitNotes" class="space-y-3">
                        <div *ngFor="let debit of profile.debitNotes" class="border border-gray-200 rounded-lg p-4">
                            <div class="flex justify-between items-start">
                                <div>
                                    <h4 class="text-md font-medium text-gray-900">Nota #{{ debit.documentNumber }}</h4>
                                    <p class="text-sm text-gray-600">{{ debit.concept }}</p>
                                    <p class="text-sm text-gray-500">{{ formatDate(debit.documentDate) }}</p>
                                </div>
                                <div class="text-right">
                                    <p class="text-lg font-semibold text-red-600">{{ formatCurrency(debit.amount) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #noDebitNotes>
                        <p class="text-gray-500 text-sm">No hay notas de débito registradas.</p>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <!-- Error State -->
    <div *ngIf="!isLoading && !profile" class="text-center py-10">
        <i class="fas fa-exclamation-triangle text-red-500 text-4xl mb-4"></i>
        <p class="text-gray-600">No se pudo cargar la información del tercero.</p>
        <button 
            (click)="goBack()" 
            class="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors">
            Volver al Listado
        </button>
    </div>
</div>